import React, { useState, useEffect } from "react";
import { Button, Container, Form, Row, Col, Spinner, Alert, Card, Dropdown } from "react-bootstrap";
import axiosInstance from '../components/AxiosInstance';
import { API_URL } from "../Config";
import { useNavigate } from "react-router-dom";
import { Chart } from "react-google-charts";

const Dashboard = () => {
  const [dashCount, setdashCount] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [period, setPeriod] = useState('weekly');  // default is weekly
  const [chartData, setChartData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getDashCounts();
    getChartData(period);
  }, []);

  const getDashCounts = async () => {
    try {
      let url = API_URL + "dashboard/getAmountByCategory";
      const res = await axiosInstance.get(url);
      if (res.data && res.data.dashCount) {
        setdashCount(res.data.dashCount);  // Adjust based on API structure
      } else {
        setError('Invalid user data structure.');
      }
      setLoading(false);
    } catch (err) {
      setError("Unable to fetch Dashboard data. Please try again!");
      setLoading(false);
    }
  };

  const handleSelect = (e) => {
    setPeriod(e);
    getChartData(e);
  }

  const getChartData = async (period) => {
    try {
      let url = API_URL + 'dashboard/getPurchasesOverTime?period=' + period;
      const res = await axiosInstance.get(url);
      if (res.data && res.data.chartResult) {
        const data = res.data.chartResult;

        const vendorTypes = Array.from(
          new Set(data.map(item => item.VendorType))
        );

        const header = [period === "weekly" ? "Week" : "Month", ...vendorTypes];
        const weekData = {};

        // Loop through the data to organize it by weeks
        data.forEach((item) => {
          const week = item.dayMonth;
          if (!weekData[week]) {
            weekData[week] = {
              week, ...vendorTypes.reduce((acc, vendor) => {
                acc[vendor] = 0; // Initialize all vendor sales to 0
                return acc;
              }, {})
            };
          }
          weekData[week][item.VendorType] = parseFloat(item.TotalAmount);
        });

        // Convert the week data object to an array of rows
        const formattedData = [header];
        Object.values(weekData).forEach((week) => {
          const row = [week.week, ...vendorTypes.map(vendor => week[vendor] || 0)];
          formattedData.push(row);
        });

        setChartData(formattedData);
        setLoading(false);
      } else {
        setError('Invalid user data structure.');
      }
      setLoading(false);
    } catch (err) {
      setError("Unable to fetch Dashboard data. Please try again!");
      setLoading(false);
    }
  };

  const chartOptions = {
    title: 'Vendor Sales Over Time (2024)',
    chartArea: { width: '80%', height: '70%' },
    isStacked: true, // Optional, to stack the bars on top of each other
    legend: { position: 'bottom' },
    hAxis: {
      title: 'Weeks',
      minValue: 0,
    },
    vAxis: {
      title: 'Total Amount',
    }
  };

  return (
    <div>
      <br /><br /><br />
      <Container>
        <Row className="mt-4">
          {loading ? (
            <Col className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </Col>
          ) : error ? (
            <Col className="d-flex justify-content-center">
              <Alert variant="danger">{error}</Alert>
            </Col>
          ) : (
            dashCount.map((item, index) => (
              <Col key={index} md={2} className="mb-4">
                <Card className="shadow-sm">
                  <Card.Header>
                    <h5>{item.VendorType}</h5>
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      <h4>₹{item.TotalAmount}</h4>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer className="text-muted">
                    <small>Last updated just now</small>
                  </Card.Footer>
                </Card>
              </Col>
            ))
          )}
        </Row>
      </Container>
      <Container>
        {/* Loading Spinner or Error */}
        {loading ? (
          <Row className="d-flex justify-content-center mt-4">
            <Spinner animation="border" variant="primary" />
          </Row>
        ) : error ? (
          <Row className="d-flex justify-content-center mt-4">
            <Alert variant="danger">{error}</Alert>
          </Row>
        ) : (
          <>
            {/* Bar Chart */}
            <Row className="mt-4">
              <Col md={12}>
                <Card>
                  <Card.Header>
                    <Row>
                      <Col>
                        <h4>Purchases over the period</h4>
                      </Col>
                      <Col className="text-end">
                        <Dropdown onSelect={handleSelect}>
                          <Dropdown.Toggle variant="primary" id="dropdown-basic">
                            {period === 'weekly' ? 'Weekly' : 'Monthly'}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item eventKey="weekly">Weekly</Dropdown.Item>
                            <Dropdown.Item eventKey="monthly">Monthly</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body>

                    <Chart
                      chartType="Bar"
                      width="100%"
                      height="400px"
                      data={chartData}
                      options={chartOptions}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Container>
    </div>
  );
};

export default Dashboard;
